module.exports = __webpack_public_path__ + "media/components/assets/sujung_07-7690fec8a75317da23c3456f87d19d70.png";